import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import vueMask from "@devindex/vue-mask";

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(store)
  .use(vueMask)
  .use(router)
  .mount("#app");
